import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../utils/auth';
import { jwtDecode } from 'jwt-decode';

const AdminOnlyRoute = ({ element: Component, ...rest }) => {
  const token = localStorage.getItem('token');
  if (!token || !isTokenValid(token)) return <Navigate to="/login" />;

  try {
    const decoded = jwtDecode(token);
    const role = decoded?.role ?? decoded?.level ?? null;
    const username = decoded?.username ?? decoded?.user ?? decoded?.sub ?? '';

    // Permitir apenas usuário admin ou com role igual a 6
    if (Number(role) === 6 || String(username) === 'admin') {
      return <Component {...rest} />;
    }
  } catch (err) {
    // ignore
  }

  return <Navigate to="/dashboard" />;
};

export default AdminOnlyRoute;
